// Mirrors Tp_Communication.Enum.InvoiceAutomationRunScheduleTextEnum — keep in sync.
const InvoiceAutomationRunScheduleEnum = {
  Daily: 'Daily',
  OnDemand: 'OnDemand',
};

export default InvoiceAutomationRunScheduleEnum;
